/* nrt-chrome-v1 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    /* ── Mega menu hover (keyboard-accessible: focusin/focusout) ───────── */
    var nav = document.querySelector('.nrt-nav');
    if (nav) {
      var navBtns = nav.querySelectorAll('[data-room]');
      var mega = nav.querySelector('.nrt-mega');
      function setActive(room) { nav.setAttribute('data-mega-active', room); }
      function clearActive() { nav.removeAttribute('data-mega-active'); }
      navBtns.forEach(function (b) {
        var room = b.getAttribute('data-room');
        b.addEventListener('mouseenter', function () { setActive(room); });
        b.addEventListener('focus', function () { setActive(room); });
      });
      nav.addEventListener('mouseleave', clearActive);
      if (mega) mega.addEventListener('mouseleave', clearActive);
    }

    /* ── Search overlay ─────────────────────────────────────────────── */
    var searchOverlay = document.querySelector('.nrt-search');
    var searchInput = searchOverlay && searchOverlay.querySelector('.nrt-search__input');
    function openSearch() {
      if (!searchOverlay) return;
      searchOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
    }
    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (searchInput) searchInput.value = '';
    }
    document.querySelectorAll('[data-nrt-open-search]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
    });
    if (searchOverlay) {
      var closeBtn = searchOverlay.querySelector('.nrt-search__close');
      if (closeBtn) closeBtn.addEventListener('click', closeSearch);
      searchOverlay.addEventListener('click', function (e) {
        if (e.target === searchOverlay) closeSearch();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && searchOverlay.getAttribute('aria-hidden') === 'false') closeSearch();
      });
      /* On submit: redirect to /search */
      var form = searchOverlay.querySelector('.nrt-search__form');
      if (form && searchInput) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var q = searchInput.value.trim();
          if (q) window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        });
      }
    }

    /* ── Mobile menu drawer ─────────────────────────────────────────── */
    var mmenu = document.querySelector('.nrt-mmenu');
    function openMmenu() {
      if (!mmenu) return;
      mmenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeMmenu() {
      if (!mmenu) return;
      mmenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      mmenu.querySelectorAll('[data-mmenu-screen]').forEach(function (s) { s.setAttribute('hidden', ''); });
      var root = mmenu.querySelector('[data-mmenu-screen="root"]');
      if (root) root.removeAttribute('hidden');
    }
    document.querySelectorAll('[data-nrt-open-mmenu]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openMmenu(); });
    });
    if (mmenu) {
      var mclose = mmenu.querySelector('[data-mmenu-close]');
      if (mclose) mclose.addEventListener('click', closeMmenu);
      mmenu.querySelectorAll('[data-mmenu-go]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var target = b.getAttribute('data-mmenu-go');
          mmenu.querySelectorAll('[data-mmenu-screen]').forEach(function (s) { s.setAttribute('hidden', ''); });
          var screen = mmenu.querySelector('[data-mmenu-screen="' + target + '"]');
          if (screen) screen.removeAttribute('hidden');
        });
      });
    }
  });
})();
